module.exports = __webpack_public_path__ + "img/judgeapp.b61b0a0c.png";